/**
 * LandscapePrompt Component
 * Suggests users rotate their device to landscape for better viewing
 * Non-blocking, dismissible, respects user preference
 */

import React, { useState, useEffect } from 'react';
import { RotateCw, X } from 'lucide-react';
import './LandscapePrompt.css';

interface LandscapePromptProps {
  pageName: string; // Unique identifier for the page (e.g., 'stakeholder-map', 'insights')
}

const LandscapePrompt: React.FC<LandscapePromptProps> = ({ pageName }) => {
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if user has previously dismissed this prompt for this page
    const dismissedKey = `landscape-prompt-dismissed-${pageName}`;
    const wasDismissed = localStorage.getItem(dismissedKey) === 'true';
    setIsDismissed(wasDismissed);
  }, [pageName]);

  const handleDismiss = () => {
    setIsDismissed(true);
    // Remember user's choice in localStorage
    const dismissedKey = `landscape-prompt-dismissed-${pageName}`;
    localStorage.setItem(dismissedKey, 'true');
  };

  // Don't show if already dismissed
  if (isDismissed) {
    return null;
  }

  return (
    <div className="landscape-prompt">
      <div className="landscape-prompt-content">
        <div className="landscape-prompt-icon">
          <RotateCw size={32} />
        </div>
        <div className="landscape-prompt-text">
          <h3>Rotate for Better View</h3>
          <p>This visualization works best in landscape mode. Please rotate your device.</p>
        </div>
        <button 
          className="landscape-prompt-dismiss"
          onClick={handleDismiss}
          aria-label="Dismiss prompt"
        >
          <X size={20} />
        </button>
      </div>
    </div>
  );
};

export default LandscapePrompt;
